import src from "IMAGE";
export default { src, width: 1448, height: 1086, blurWidth: 0, blurHeight: 0};
